// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-search[data-v-6217ca5a] {\n  width: 24rem !important;\n  margin-right: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
